<template>
    <div :class="one ? 'container containerNew' : 'container'">
        <div class="common-header-wrap">
            <mt-header :title="$t('MyTeam')" class="common-header">
                <mt-button slot="left" icon="back" @click="one ? onPage('index') : $router.go(-1)"></mt-button>
            </mt-header>
        </div>
        <div class="notes">
            <div class="total">
                <div>
                <div class="total-title">{{$t('number_of_people')}}</div>
                <div class="total-content">{{teamCount}}</div>
                </div>
            </div>
            <div class="total">
                <div>
                    <div class="total-title">{{$t('MyCommission')}}</div>
                    <div class="total-content">{{teamTotal}}</div>
                </div>
                <div>
                    <div class="total-title">{{$t('Team Commission')}}</div>
                    <div class="total-content">{{childTeamTotal}}</div>
                </div>
            </div>

            <div class="notes_box">
                <div class="notes_box_le">
                    <div>{{$t('Level')}}</div>
                    <div>{{$t('number_of_people')}}</div>
                </div>
                <div class="notes_box_ri">
                    <div class="list" v-for="el in teamList" :key="el.id">
                        <div>{{ el.level }}</div>
                        <div>{{ el.count }}</div>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</template>
<script>
import { GetMyTeam } from '../../../api/memberOne'
export default {
    name: 'HuntNotes',
    data() {
        return {
            page: 1,
            limit: 10,
            show: true,
            teamCount: 0,
            teamTotal: 0,
            childTeamTotal: 0,
            teamList: [],
        }
    },
    props: {
        one: {
            default: false,
            type: Boolean
        },
    },
    created(){
        this.getTeamList()
    },
    methods: {
        more(){
            this.page++
            this.getTeamList()
        },
        onPage(v, val) {
            this.$emit('onPage', v, val)
        },
        goNav(name = 'HuntIndex', val){
            this.$router.push({ name: name, query: { data: val }  })
        },
        getTeamList(){
            GetMyTeam({
                page:1,
                limit: 1000
            }, 'one').then(res=>{
                if (res && res.result) {
                    this.childTeamTotal = res.result.child_commission_total
                    this.teamTotal = res.result.commission_total
                    this.teamCount = res.result.team_count
                    this.teamList = res.result.team_list
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.containerNew{
    height: 100% !important;
}
.total{
    text-align: center;
    display: flex;
    justify-content:space-around;
    .total-title{font-size:14px;}
    .total-content{font-size:26px;color:#EC3031;padding:10px 0 20px;}
}
.notes_box_ri .list div {
    flex: 1; /* 平均分配水平空间 */
    text-align: center; /* 内容在单元格内居中 */
}
.container{
    display: flex;
    flex-direction: column;
    height: 100vh;
    width: 100%;
    .flex{
        display: flex;
    }
    .notes{
        overflow-y: auto;
        display: flex;
        flex: 1;
        flex-direction: column;
        padding: 17px 4px 20px;
        box-sizing: border-box;
        
        .notes_box{
            margin-bottom: 10px;
            box-shadow: 0px 5px 5px 0px rgba(254,109,98,0.1);
            box-sizing: border-box;
            position: relative;

            .notes_box_le{
                display: flex;
                justify-content:space-around;
                background: #FE3420;
                border-radius: 10px;
                padding: 10px;
                box-sizing: border-box;
                color: #ffffff;
                font-size: 14px;
            }
            .notes_box_ri{
                .list{
                    display: flex;
                    justify-content:space-around;
                    background: #fff;
                    flex: 1;
                    padding: 10px;
                    font-size: 14px;
                    color: #333333;
                }
                .list:nth-child(even){
                    background-color: #eeeeee;
                }
            }
        }
    }
}
</style>
